import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AboutGene = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{maxWidth: '1000px', margin: '0 auto', padding: '2rem'}}>
      
      {/* Hero Section */}
      <div style={{background: 'white', borderRadius: '12px', padding: '3rem', marginBottom: '3rem', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', textAlign: 'center'}}>
        <h1 style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#2e7d32', marginBottom: '1rem'}}>
          Gene: Your Expert Genealogical Research Partner
        </h1>
        <h2 style={{fontSize: '1.5rem', color: '#8b4513', fontWeight: 'normal'}}>
          Powered by Generational Nexus (GNology)
        </h2>
      </div>

      {/* Generational Nexus (GNology) Section */}
      <div style={{background: 'white', borderRadius: '12px', padding: '2.5rem', marginBottom: '2rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'}}>
        <h2 style={{fontSize: '1.8rem', color: '#8b4513', marginBottom: '1.5rem'}}>
          Powered by Generational Nexus (GNology)
        </h2>
        <p style={{fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '1.5rem'}}>
          Gene is powered by <strong>Generational Nexus (GNology)</strong> — a revolutionary genealogical knowledge framework that serves as the central connection point linking all family generations across time. This specialized system enables me to assist with complex family history research by creating powerful nexus points between past, present, and future family stories.
        </p>
        
        <div style={{background: '#f8f4e8', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem', borderLeft: '4px solid #8b4513'}}>
          <p style={{fontSize: '1.05rem', lineHeight: '1.7', color: '#444', margin: 0}}>
            The Generational Nexus framework represents a comprehensive system of genealogical methodologies, historical context understanding, and advanced research strategies that I use to help you explore your family's past with unprecedented depth and precision.
          </p>
        </div>

        <p style={{fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '1rem', fontWeight: 'bold'}}>
          This Generational Nexus framework allows me to:
        </p>
        <ul style={{paddingLeft: '1.5rem', fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '1.5rem'}}>
          <li style={{marginBottom: '0.75rem'}}>Create strategic connections between different generations of your family</li>
          <li style={{marginBottom: '0.75rem'}}>Guide you through sophisticated genealogical research processes</li>
          <li style={{marginBottom: '0.75rem'}}>Analyze historical documents with advanced pattern recognition</li>
          <li style={{marginBottom: '0.75rem'}}>Provide comprehensive historical context for different time periods and regions</li>
          <li style={{marginBottom: '0.75rem'}}>Develop targeted research strategies for complex family history challenges</li>
          <li style={{marginBottom: '0.75rem'}}>Transform disconnected facts into cohesive family narratives</li>
        </ul>
        <p style={{fontSize: '1.1rem', lineHeight: '1.7', color: '#444'}}>
          As Gene, I'm designed specifically to support your family history journey using this <strong>Generational Nexus (GNology)</strong> framework, combining cutting-edge technical research approaches with a deep understanding of the personal significance of discovering your family's story.
        </p>
      </div>

      {/* Advanced Document Processing & Analysis */}
      <div style={{background: 'white', borderRadius: '12px', padding: '2.5rem', marginBottom: '2rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'}}>
        <h2 style={{fontSize: '1.8rem', color: '#2e7d32', marginBottom: '1.5rem'}}>
          Advanced Document Processing & Analysis
        </h2>
        <p style={{fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '1.5rem'}}>
          One of my most powerful capabilities is sophisticated document upload and analysis, seamlessly integrated with the Generational Nexus framework:
        </p>
        
        <div style={{background: '#f0f8f0', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem'}}>
          <h3 style={{fontSize: '1.3rem', color: '#1b5e20', marginBottom: '0.8rem'}}>Universal Document Support</h3>
          <p style={{fontSize: '1.05rem', lineHeight: '1.6', color: '#444', margin: 0}}>
            Upload any genealogical document including JPG, PNG, PDF, DOC, DOCX, and TXT files. I process census records, vital records, military documents, land records, and family photographs with equal expertise.
          </p>
        </div>

        <div style={{background: '#f0f8f0', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem'}}>
          <h3 style={{fontSize: '1.3rem', color: '#1b5e20', marginBottom: '0.8rem'}}>Intelligent OCR Technology</h3>
          <p style={{fontSize: '1.05rem', lineHeight: '1.6', color: '#444', margin: 0}}>
            My Optical Character Recognition capabilities automatically extract text from handwritten census entries, vital records, and historical documents, handling various document qualities and conditions.
          </p>
        </div>

        <div style={{background: '#f0f8f0', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem'}}>
          <h3 style={{fontSize: '1.3rem', color: '#1b5e20', marginBottom: '0.8rem'}}>Systematic Information Extraction</h3>
          <p style={{fontSize: '1.05rem', lineHeight: '1.6', color: '#444', margin: 0}}>
            For each document, I identify and organize names (including variations), dates, locations, relationships, occupations, and biographical details while providing immediate recognition of document content.
          </p>
        </div>

        <h3 style={{fontSize: '1.3rem', color: '#2e7d32', marginTop: '1.5rem', marginBottom: '1rem'}}>Document-Specific Expertise:</h3>
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem'}}>
          <div style={{background: '#f9f9f9', padding: '1rem', borderRadius: '6px', border: '1px solid #e0e0e0'}}>
            <h4 style={{color: '#2e7d32', marginBottom: '0.5rem'}}>Census Records</h4>
            <ul style={{paddingLeft: '1.2rem', margin: 0, fontSize: '0.95rem', color: '#555'}}>
              <li>Complete household analysis including relationships</li>
              <li>Occupations, property values, and neighboring family connections</li>
            </ul>
          </div>
          <div style={{background: '#f9f9f9', padding: '1rem', borderRadius: '6px', border: '1px solid #e0e0e0'}}>
            <h4 style={{color: '#2e7d32', marginBottom: '0.5rem'}}>Vital Records</h4>
            <ul style={{paddingLeft: '1.2rem', margin: 0, fontSize: '0.95rem', color: '#555'}}>
              <li>Full name extraction, exact dates/locations</li>
              <li>Parents' information, witnesses, and discrepancy identification</li>
            </ul>
          </div>
          <div style={{background: '#f9f9f9', padding: '1rem', borderRadius: '6px', border: '1px solid #e0e0e0'}}>
            <h4 style={{color: '#2e7d32', marginBottom: '0.5rem'}}>Military Records</h4>
            <ul style={{paddingLeft: '1.2rem', margin: 0, fontSize: '0.95rem', color: '#555'}}>
              <li>Service details, unit information</li>
              <li>Physical descriptions, and pension data</li>
            </ul>
          </div>
          <div style={{background: '#f9f9f9', padding: '1rem', borderRadius: '6px', border: '1px solid #e0e0e0'}}>
            <h4 style={{color: '#2e7d32', marginBottom: '0.5rem'}}>Family Photographs</h4>
            <ul style={{paddingLeft: '1.2rem', margin: 0, fontSize: '0.95rem', color: '#555'}}>
              <li>Visual analysis focusing on dating clues</li>
              <li>Clothing, photography styles, and historical context</li>
            </ul>
          </div>
        </div>

        <div style={{background: '#e8f5e9', padding: '1rem', borderRadius: '6px', marginTop: '1.5rem'}}>
          <p style={{fontSize: '1.05rem', color: '#1b5e20', fontWeight: 'bold', margin: 0}}>
            Flexible Export Options: Download processed documents in TXT, JSON, or Markdown formats for preservation and integration with your research systems.
          </p>
        </div>
      </div>

      {/* Expert Guidance at Every Step */}
      <div style={{background: 'white', borderRadius: '12px', padding: '2.5rem', marginBottom: '2rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'}}>
        <h2 style={{fontSize: '1.8rem', color: '#2e7d32', marginBottom: '1.5rem'}}>
          Expert Guidance at Every Step
        </h2>
        <p style={{fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '1.5rem'}}>
          Whether you're just beginning your family history journey or have been researching for decades, I provide personalized support tailored to your specific research goals:
        </p>
        <ul style={{paddingLeft: '1.5rem', fontSize: '1.1rem', lineHeight: '1.7', color: '#444'}}>
          <li style={{marginBottom: '1rem'}}>
            <strong style={{color: '#2e7d32'}}>Strategic Research Planning:</strong> I create customized research roadmaps that maximize your time and efforts, integrating findings from uploaded documents into comprehensive research strategies.
          </li>
          <li style={{marginBottom: '1rem'}}>
            <strong style={{color: '#2e7d32'}}>Document Analysis Mastery:</strong> I extract critical clues from records that might otherwise be overlooked, connecting information across multiple documents to reveal hidden family connections.
          </li>
          <li style={{marginBottom: '1rem'}}>
            <strong style={{color: '#2e7d32'}}>Historical Context Integration:</strong> I place your ancestors within the historical events that shaped their lives, using both uploaded documents and extensive historical knowledge.
          </li>
          <li style={{marginBottom: '1rem'}}>
            <strong style={{color: '#2e7d32'}}>Breakthrough Methodologies:</strong> When traditional approaches fail, I offer specialized techniques to overcome research obstacles, including cluster research, indirect evidence analysis, and timeline correlation.
          </li>
          <li style={{marginBottom: '1rem'}}>
            <strong style={{color: '#2e7d32'}}>Narrative Development:</strong> I transform disconnected facts into compelling family narratives that resonate across generations, weaving together information from all your sources.
          </li>
        </ul>
      </div>

      {/* Beyond Basic Organization */}
      <div style={{background: 'white', borderRadius: '12px', padding: '2.5rem', marginBottom: '2rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'}}>
        <h2 style={{fontSize: '1.8rem', color: '#2e7d32', marginBottom: '1.5rem'}}>
          Beyond Basic Organization
        </h2>
        <p style={{fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '1.5rem'}}>
          I don't just collect genealogical data—I transform it into meaningful family history:
        </p>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem'}}>
          <div style={{background: '#f8faf8', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e0f2e0'}}>
            <h3 style={{fontSize: '1.2rem', color: '#1b5e20', marginBottom: '0.8rem'}}>Dynamic Book Creation</h3>
            <p style={{fontSize: '1rem', lineHeight: '1.6', color: '#555'}}>
              I organize your family history into professionally structured books with customized tables of content and chapter organization, incorporating insights from all your uploaded documents.
            </p>
          </div>
          
          <div style={{background: '#f8faf8', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e0f2e0'}}>
            <h3 style={{fontSize: '1.2rem', color: '#1b5e20', marginBottom: '0.8rem'}}>Seamless Research Integration</h3>
            <p style={{fontSize: '1rem', lineHeight: '1.6', color: '#555'}}>
              Add, change, or remove information with ease while maintaining perfect organization across all your sources and findings.
            </p>
          </div>
          
          <div style={{background: '#f8faf8', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e0f2e0'}}>
            <h3 style={{fontSize: '1.2rem', color: '#1b5e20', marginBottom: '0.8rem'}}>Presentation Development</h3>
            <p style={{fontSize: '1rem', lineHeight: '1.6', color: '#555'}}>
              Create impactful family reunion presentations that engage relatives of all ages, featuring analysis from your historical documents and photographs.
            </p>
          </div>
          
          <div style={{background: '#f8faf8', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e0f2e0'}}>
            <h3 style={{fontSize: '1.2rem', color: '#1b5e20', marginBottom: '0.8rem'}}>Visual Storytelling</h3>
            <p style={{fontSize: '1rem', lineHeight: '1.6', color: '#555'}}>
              Receive guidance on selecting powerful imagery, including book covers that reflect your family's unique journey, plus expert analysis of family photographs for dating and context.
            </p>
          </div>
          
          <div style={{background: '#f8faf8', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e0f2e0'}}>
            <h3 style={{fontSize: '1.2rem', color: '#1b5e20', marginBottom: '0.8rem'}}>Professional Research Tools</h3>
            <p style={{fontSize: '1rem', lineHeight: '1.6', color: '#555'}}>
              Access structured templates for census extraction, vital record analysis, and family group sheets that ensure comprehensive data capture from every source.
            </p>
          </div>
          
          <div style={{background: '#f8faf8', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e0f2e0'}}>
            <h3 style={{fontSize: '1.2rem', color: '#1b5e20', marginBottom: '0.8rem'}}>Research Quality Assurance</h3>
            <p style={{fontSize: '1rem', lineHeight: '1.6', color: '#555'}}>
              I evaluate document reliability, identify primary vs. secondary sources, note potential transcription errors, and recommend verification strategies.
            </p>
          </div>
        </div>
      </div>

      {/* The Partner You've Been Searching For */}
      <div style={{background: 'white', borderRadius: '12px', padding: '2.5rem', marginBottom: '2rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'}}>
        <h2 style={{fontSize: '1.8rem', color: '#2e7d32', marginBottom: '1.5rem'}}>
          The Partner You've Been Searching For
        </h2>
        <p style={{fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '1.5rem'}}>
          Family history research can be challenging, but you don't have to do it alone. With my assistance powered by the Generational Nexus framework, you'll move beyond basic ancestry charts to discover the rich contexts and personal stories that make your family history truly meaningful.
        </p>
        <p style={{fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '1.5rem'}}>
          My integrated approach combines sophisticated document analysis with expert genealogical guidance, ensuring that every piece of evidence—whether a faded census page or a family photograph—contributes to the complete story of your family's journey through time. Together, we'll unlock the full potential of your genealogical research and create lasting family narratives that honor your ancestors' legacy.
        </p>
      </div>

      {/* Call to Action */}
      <div style={{background: '#faf6f1', borderRadius: '12px', padding: '3rem', textAlign: 'center'}}>
        <h2 style={{fontSize: '1.6rem', color: '#2e7d32', marginBottom: '1.5rem'}}>
          Ready to Transform Your Family History Research?
        </h2>
        <div style={{display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap'}}>
          <Link 
            to="/register" 
            style={{
              padding: '1rem 2rem', 
              background: '#2e7d32', 
              color: 'white', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontSize: '1.1rem',
              fontWeight: '500',
              transition: 'transform 0.3s',
              display: 'inline-block'
            }}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            Start Your Journey with Gene
          </Link>
          <Link 
            to="/research" 
            style={{
              padding: '1rem 2rem', 
              border: '2px solid #2e7d32', 
              color: '#2e7d32', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontSize: '1.1rem',
              fontWeight: '500'
            }}
          >
            Explore Gene's Features
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutGene;
